"use strict";

import angular from "angular";

angular.module("nucont.plans", ["nucont.shared"]);
require("./plans.routes");
